import produce from "immer";
import { RESET_ACTIVITY } from "./reset";

// Actions
export const INIT = "valueRanking/INIT";
export const ADD = "valueRanking/ADD";
export const SHOW_RESULT = "valueRanking/SHOW_RESULT";
export const EXPAND = "valueRanking/EXPAND";
export const REMOVE = "valueRanking/REMOVE";
export const RESET = "valueRanking/RESET";

const initialState = {
  rankings: {},
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  return produce(state, (draft) => {
    switch (action.type) {
      case ADD: {
        const { id, itemID, resetID } = action.props;

        if (!id || !itemID) {
          throw new Error(
            "must provide an ID and itemID to value ranking progress action"
          );
        }

        let timeEntered = new Date().getTime();

        if (!draft.rankings) {
          draft.rankings = {
            [id]: {
              items: { [itemID]: { itemID, timeEntered } },
              showResults: false,
              resetID: resetID,
            },
          };
          break;
        }

        if (!draft.rankings?.[id]) {
          draft.rankings[id] = {
            items: { [itemID]: { itemID, timeEntered } },
            showResults: false,
            resetID: resetID,
          };
          break;
        }

        //the value ranking screen only allows user to select 5 values, hence the break here to prevent them from
        //adding any more.
        if (Object.keys(draft.rankings[id].items).length === 5) {
          break;
        }

        if (!draft.rankings[id].itemID) {
          draft.rankings[id].items[itemID] = { itemID, timeEntered };
          break;
        }

        break;
      }

      case REMOVE: {
        const { id, itemID } = action.props;

        if (!id || !itemID) {
          throw new Error(
            "must provide an ID and itemID to value ranking progress action"
          );
        }
        if (draft.rankings[id]?.items[itemID]) {
          delete draft.rankings[id].items[itemID];
          break;
        }
      }

      case RESET: {
        const { id } = action.props;

        if (!id) {
          break;
        }

        if (!draft.rankings) {
          break;
        }

        draft.rankings[id].items = {};
        break;
      }

      case RESET_ACTIVITY: {
        const { id } = action;
        if (!id) {
          break;
        }

        if (!draft.rankings) {
          break;
        }

        for (let rankingID in draft.rankings) {
          // check also if property is not inherited from prototype
          if (draft.rankings.hasOwnProperty(rankingID)) {
            const { resetID } = state.rankings[rankingID];

            if (resetID == id) {
              draft.rankings[rankingID] = {
                items: {},
                showResults: false,
                resetID: id,
              };
            }
          }
        }
        break;
      }

      case SHOW_RESULT: {
        const { id, showResults } = action.props;

        if (!draft.rankings[id]) {
          break;
        }

        draft.rankings[id].showResults = showResults;

        break;
      }
    }
  });
}

// Action Creators
export function initRanking(props) {
  return { type: INIT, props };
}

/**
 *
 * @param {Object} props
 * @param {string|number} props.id - ranking id
 * @param {string|number} props.itemID - the value item id
 */
export function setRankingValue(props) {
  return { type: ADD, props };
}

/**
 *
 * @param {Object} props
 * @param {string|number} props.id - ranking id
 * @param {string|number} props.itemID - the value item id
 */
export function removeRankingValue(props) {
  return { type: REMOVE, props };
}

/**
 *
 * @param {Object} props
 * @param {string|number} props.id - ranking id
 * @param {string|number} props.itemID - the value item id
 */
export function resetRanking(props) {
  return { type: RESET, props };
}

/**
 *
 * @param {Object} props
 * @param {string|number} props.id - ranking id
 * @param {bool} props.showResults
 */
export function setRankingResults(props) {
  return { type: SHOW_RESULT, props };
}

// selector
export function selectRanking(state) {
  return state.valueRanking;
}
